export default {
  actions: {
    createLocation({ dispatch }, location) {
      this.$authorize('edit', 'Organization')

      // Accepts address or id in location
      return Vue.$http
        .post(`admin/organizations/${location.organization.id}/locations`, {
          location
        })
        .then(() => dispatch('fetch', location.organization.id))
    },
    removeLocation({ dispatch }, location) {
      this.$authorize('edit', 'Organization')

      return Vue.$http
        .delete(
          `admin/organizations/${location.organization.id}/locations/${
            location.id
          }`
        )
        .then(() => dispatch('fetch', location.organization.id))
    }
  }
}
